export default __webpack_public_path__ + "static/media/Into the Sack You Go.78e3a09a.png";